import React from 'react';
import shallow from 'zustand/shallow';
import useStore from '..';
import { FocusSlice } from '../focus';

export interface UseFocusHook {
  focus: FocusSlice['focus'];
  actions: { setFocus: FocusSlice['setFocus'] };
}

export const useFocus = (index?: number): UseFocusHook => {
  const { focus, setFocus } = useStore((state) => state.focus, shallow);
  React.useEffect(() => {
    if (!Number.isNaN(index)) setFocus(index);
  }, []);
  return {
    focus,
    actions: { setFocus },
  };
};
